let drawingPolyfillPromise = null;

export function loadDrawingPolyfill() {
    if (drawingPolyfillPromise) {
        return drawingPolyfillPromise;
    }

    drawingPolyfillPromise = new Promise((resolve, reject) => {
        // Already loaded
        if (window.google?.maps?.drawing?.DrawingManager) {
            resolve();
            return;
        }

        const polyfill = document.createElement("script");

        polyfill.src = "/drawingPolyfill/mcx-drawing-polyfill.js";

        polyfill.onload = () => {
            const shapes = document.createElement("script");

            shapes.src = "/drawingPolyfill/mcx-drawing-shapes.js";

            shapes.onload = () => {
                resolve();
            };

            shapes.onerror = () => {
                reject(
                    new Error("Failed to load mcx-drawing-shapes.js")
                );
            };

            document.head.appendChild(shapes);
        };

        polyfill.onerror = () => {
            reject(
                new Error("Failed to load mcx-drawing-polyfill.js")
            );
        };

        document.head.appendChild(polyfill);
    });

    return drawingPolyfillPromise;
}